import { mutatorAction } from 'satcheljs';
import { smartSchedulePollingState } from '../store/smartSchedulePollingState';
import { ISmartScheduleGenerationJobStatusEntity } from 'sh-models/job/SmartScheduleGenerationJobStatusEntity';

// Polling is always on globally; only update status snapshot.
export const updateSmartSchedulePollingStatus = mutatorAction('updateSmartSchedulePollingStatus', function updateSmartSchedulePollingStatus(entity: ISmartScheduleGenerationJobStatusEntity | undefined) {
    if (!entity) { return; }
    smartSchedulePollingState().statusEntity = entity;
    smartSchedulePollingState().status = entity.status;
    smartSchedulePollingState().jobId = entity.jobId;
    smartSchedulePollingState().lastUpdated = Date.now();
});

// Clear polling snapshot (set to idle) after generation fully reviewed or dismissed.
export const clearSmartSchedulePollingJob = mutatorAction('clearSmartSchedulePollingJob', function clearSmartSchedulePollingJob() {
    smartSchedulePollingState().statusEntity = undefined;
    smartSchedulePollingState().status = undefined;
    smartSchedulePollingState().jobId = undefined;
    smartSchedulePollingState().lastUpdated = Date.now();
});
